import { OptionType } from "../../shared/components/BaseAsyncPaginate";
import { createLoadOptions } from "../../service/createLoadOptions";
import {
  GetVendorsResponse,
  Vendor,
} from "../models/response/get-vendors-response";
import { getPaginatedByNameVendors } from "./vendor-service";

export interface VendorsOption extends OptionType {
  data: Vendor;
}

const fetchVendors = async (
  page: number,
  perPage: number,
  searchQuery?: string
): Promise<GetVendorsResponse> => {
  return getPaginatedByNameVendors({ page, perPage, searchQuery });
};

export const vendorsMapper = (v: Vendor): VendorsOption => {
  return {
    value: v.id,
    label: `${v.name}, ${v.city}, ${v.state}, ${v.contactName}`,
    data: v,
  };
};

export const loadVendors = createLoadOptions(fetchVendors, vendorsMapper);
